import React, { memo } from "react";
// types
import { CouponFooterSectionProps } from "./types";
// styles
import { Container, CTAContainer, IconWrapper, SavingsCallout, StyledText } from "./styles";
// constants
import { COUPON_SECTION_FOOTER_COMMS_DATA_TEST_ID as TEST_ID } from "@swiggy-private/cart-test-ids";
import { CTA_TEXT, SPARKLE_ICON } from "./constants";
//dls
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
//utils
import { isEmpty } from "@swiggy-private/js-utils";
import { useEffectOnce } from "@swiggy-private/core-ui";

const CouponFooterSection = ({
    savingsText,
    onFooterCTAClick,
    isFooterCTAdisabled,
    couponApplied,
    isCouponAvailable,
    CTAImpression,
}: CouponFooterSectionProps) => {
    useEffectOnce(() => {
        CTAImpression({ savingsCallout: savingsText, ctaText: couponApplied ? CTA_TEXT.GOT_IT : CTA_TEXT.APPLY });
    });

    return (
        <Container data-testid={TEST_ID.CONTAINER}>
            {isCouponAvailable && !isEmpty(savingsText) && (
                <SavingsCallout>
                    <IconWrapper
                        cloudinaryId={SPARKLE_ICON.IMAGE_ID}
                        alt={SPARKLE_ICON.ALT}
                        width={SPARKLE_ICON.WIDTH}
                        height={SPARKLE_ICON.HEIGHT}
                        leftIcon
                    />
                    <StyledText variant="V2.body2.neutral.medium" color="positive">
                        {savingsText}
                    </StyledText>
                    <IconWrapper
                        cloudinaryId={SPARKLE_ICON.IMAGE_ID}
                        alt={SPARKLE_ICON.ALT}
                        width={SPARKLE_ICON.WIDTH}
                        height={SPARKLE_ICON.HEIGHT}
                        rightIcon
                    />
                </SavingsCallout>
            )}
            <CTAContainer>
                <SuperButton
                    isDisabled={isFooterCTAdisabled}
                    variant="fullwidth"
                    buttonType="primary"
                    buttonSize="large"
                    onClick={onFooterCTAClick}
                    data-testid={TEST_ID.CTA}
                >
                    {couponApplied ? CTA_TEXT.GOT_IT : CTA_TEXT.APPLY}
                </SuperButton>
            </CTAContainer>
        </Container>
    );
};

export default memo(CouponFooterSection);
